// src/app/core/mainPage/mainPagecomp/VideoSection/VideoCard.tsx
interface VideoCardProps {
  src: string;
  alt: string;
}

export function VideoCard({ src, alt }: VideoCardProps) {
  return (
    <div className="relative rounded-xl overflow-hidden border border-white/20 dark:border-white/20">
      <img src={src} alt={alt} className="w-full h-44 md:h-52 object-cover" />
      <div className="absolute inset-0 bg-black/10" />
    </div>
  );
}